import { useTranslation } from "react-i18next";
import clsx from "clsx";

type Props = {
  className?: string;
  onClick: () => void;
};

export default function SettingsResetButton({ onClick, className }: Props) {
  const { t } = useTranslation("chat");

  return (
    <div className="h-[2.625rem] flex items-center justify-center">
      <button
        type="button"
        className={clsx("text-gray-400 hover:underline hover:text-white transition-all", className)}
        onClick={onClick}
      >
        {t("chat.defaultSettings")}
      </button>
    </div>
  );
}
